import { render, staticRenderFns } from "./VideoDirector.vue?vue&type=template&id=50534b24&"
import script from "./VideoDirector.vue?vue&type=script&lang=js&"
export * from "./VideoDirector.vue?vue&type=script&lang=js&"
import style0 from "./VideoDirector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports